import accountImgDefault from "@/assets/svgs/account-img-default.svg";
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as IconDownArrow } from '@/assets/svgs/caret-down.svg';
import { ReactComponent as IconFolderShow } from '@/assets/svgs/chevron-down-medium.svg';
import { ReactComponent as IconFolderHide } from '@/assets/svgs/chevron-up-medium.svg';
import { ToastContext } from '@/context/toast/index';
import usePackages from '@/hooks/use-packages/index.js';
import useStaticData from "@/hooks/use-static-data/index";
import { useParams } from '@/lib/router-dom/index';
import moment from 'moment';
import { useContext, useEffect, useRef, useState } from "react";

export function GetOrganizationName(data, staticData) {
    const currentOrgSysData = staticData?.orgs.find((item) => item.orgId === data?.senderOrgId)
    return currentOrgSysData?.name
}

export function GetImageSource(data, staticData) {
    const currentOrgSysData = staticData?.orgs.find((item) => item.orgId === data?.senderOrgId)
    if (currentOrgSysData?.iconUrl) return currentOrgSysData.iconUrl;
    return accountImgDefault;
}

export function OnImageError(event) {
    const { target } = event;
    if (!target) {
        return;
    }
    target.onerror = null;
    target.src = accountImgDefault;
}

const PackageComments = ({ packageInfo }) => {

	const { eclipId } = useParams();
    const [messagesLists, setMessagesLists] = useState([]);
    const [userMessage, setUserMessage] = useState("");
    const bottomRef = useRef(null);
    const commentType = {
        package: "PACKAGE"
    };
    const [selectedCommentText, setSelectedCommentText] = useState("")
    const staticData = useStaticData();

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messagesLists]);

    /*=================================================
        Get Package Comments
    /================================================*/

    const { getPackageComments, packageCommentsData, postPackageComments, packageErrorMsg } = usePackages();
    const { addToastMessage } = useContext(ToastContext)

    useEffect(() => {
        getPackageComments(eclipId)
    }, [eclipId])

    useEffect(() => {
        const comments = packageCommentsData?.comments;
        setMessagesLists(comments)
    }, [packageCommentsData])

    useEffect(() => {
        if (packageErrorMsg) addToastMessage(packageErrorMsg, 'error')
    }, [packageErrorMsg])

    async function storeMessageInLists() {
        if (userMessage) {
            const data = {
                "nodeId": eclipId,
                "type": commentType.package,
                "comments": [
                    {
                        "text": userMessage
                    }
                ]
            }
            postPackageComments(data);
            setUserMessage("");
        }
    }

    const commentData = messagesLists?.map((item, index) => {
        return (
            <>
                <div className="package-comments__messages-container" key={item.id}>
                    <div className="package-comments__icon-user">
                        <img data-testid="account-img"
                            src={GetImageSource(item, staticData)}
                            onError={OnImageError}
                        />
                    </div>
                    <div className="eclip-activity-log--label eclip-modal-flex">
                        <div className="package-comments__title">{GetOrganizationName(item, staticData)}</div>
                        <div className="package-comments__timestamp">{moment(new Date(item?.created)).format('DD MMM, HH:mm')}</div>
                    </div>
                    <div className="package-comments__information-heading">
                        {
                            index != selectedCommentText &&
                            <>
                                <div className="package-comments__information" dangerouslySetInnerHTML={{ __html: item?.text.substring(0, 299) }}></div>
                                {item?.text.length > 299 && <div className="package-comments__see-more" onClick={() => setSelectedCommentText(index)}>See More <IconFolderShow /></div>}
                            </>
                        }
                        {
                            index == selectedCommentText &&
                            <>
                                <div className="package-comments__information-full" dangerouslySetInnerHTML={{ __html: item?.text }}></div>
                                {item?.text.length > 299 && <div className="package-comments__see-more" onClick={() => setSelectedCommentText("")}>See Less <IconFolderHide /></div>}
                            </>
                        }
                    </div>
                    <div className="package-comments__log--subcontent">{item?.updatedById}</div>
                    <hr />
                </div>
            </>
        )
    })

    return (
        <>
            <div className="package-comments__container">
                <div className="package-comments__container-message-lists">
                    {messagesLists?.length > 0 && commentData}
                    <div className="package-comments__bottom-ref" ref={bottomRef} />
                    {(!messagesLists || messagesLists?.length === 0) && <div className="package-comments__no-messages-container">
                        No Comments Found
                    </div>}
                </div>

                <div className="package-comments__input-container">
                    <div className="package-comments__user-icon">
                        <img data-testid="account-img"
                            src={GetImageSource(
                                packageInfo?.iconUrl
                            )}
                            onError={OnImageError}
                        />
                    </div>
                    <div className="package-comments__input-box">
                        <input type="text" placeholder="Your comment" onChange={(event) => setUserMessage(event.target.value)} value={userMessage} />
                    </div>
                    <div className="package-comments__send-button" onClick={() => storeMessageInLists()}>
                        <span className="package-comments__send-button__text">Post</span>
                        <IconDownArrow />
                    </div>
                </div>
            </div>
        </>
    )

};

export default PackageComments;
